import { Button, Card, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { capitalize } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useCreateCalendarSync } from 'modules/cronofy/components/ConnectMyCalendar/useCreateCalendarSync'
import { useAccessCalendarSync } from 'modules/personal_settings/components/Settings/ExternalCalendar/useAccessCalendarSync'
import { SessionData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

interface CalendarInvitesCardProps {
  data: SessionData
  setCurrentData: (value: SessionData) => void
}

const CalendarInvitesCard = ({ data, setCurrentData }: CalendarInvitesCardProps) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const { accessCalendarSync, loading } = useAccessCalendarSync(accessId)
  const { createCalendarSync, loading: creating } = useCreateCalendarSync()
  const isCalendarConnected = !!accessCalendarSync?.sub

  if (loading) return null

  const handleToggle = (value: boolean) => {
    setCurrentData({ ...data, sendCalendarInvites: value })
  }

  const handleConnectCalendar = async () => {
    if (accessCalendarSync?.oauthUrl) {
      window.location.href = accessCalendarSync.oauthUrl
      return
    }
    const result = await createCalendarSync({ accessId })
    const handled = handleResult(result, () => undefined)
    if (handled.success && handled.data.calendarSync && handled.data.calendarSync.oauthUrl) {
      window.location.href = handled.data.calendarSync.oauthUrl
    }
  }

  return (
    <Card>
      <Card.Title
        size="small"
        action={
          <TogglerCheckbox
            value={data.sendCalendarInvites ?? false}
            onChange={handleToggle}
            disabled={!isCalendarConnected}
          />
        }
      >
        {i18n.t('trainings.trainings_revamp.sessions.new_session_modal.calendar_invites.title')}
      </Card.Title>
      {isCalendarConnected ? (
        <Card.ExpandableContent expanded>
          <Text.Normal size="200">
            {i18n.tView(
              'trainings.trainings_revamp.sessions.new_session_modal.calendar_invites.synced_description',
              {
                provider: (
                  <Text.Normal weight="bold">
                    {capitalize(accessCalendarSync.provider ?? '')}
                  </Text.Normal>
                ),
                profileName: (
                  <Text.Normal weight="bold">{accessCalendarSync.profileName}</Text.Normal>
                ),
              }
            )}
          </Text.Normal>
        </Card.ExpandableContent>
      ) : (
        <Card.Description>
          {i18n.t(
            'trainings.trainings_revamp.sessions.new_session_modal.calendar_invites.description'
          )}
        </Card.Description>
      )}
      {!isCalendarConnected && (
        <Card.ExpandableContent expanded>
          <Button type="primary" onClick={handleConnectCalendar} loading={creating}>
            {i18n.t(
              'trainings.trainings_revamp.sessions.new_session_modal.calendar_invites.connect_button'
            )}
          </Button>
        </Card.ExpandableContent>
      )}
    </Card>
  )
}

export default CalendarInvitesCard
